var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLowRed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.0001C17.52 22.0001 22 17.5201 22 12.0001C22 6.48006 17.52 2.00006 12 2.00006C6.48 2.00006 2 6.48006 2 12.0001C2 17.5201 6.48 22.0001 12 22.0001ZM13 12.0001H16L12 16.0001L8 12.0001H11V8.00006H13V12.0001Z",
    fill: "#FF4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowRed);
export default __webpack_public_path__ + "static/media/low-red.15b77e529a68cbf1a2cec85323160dbf.svg";
export { ForwardRef as ReactComponent };